// src/pages/HolidayManage.jsx
import React, { useEffect, useState } from "react";
import api from "../api";

export default function HolidayManage() {
  const [user, setUser] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [holidays, setHolidays] = useState([]);
  const [holidayForm, setHolidayForm] = useState({
    date: "",
    name: "",
    holiday_type: "공휴일",
  });
  const [holidayYear, setHolidayYear] = useState(new Date().getFullYear());
  const [editingHoliday, setEditingHoliday] = useState(null);

  document.title = "공휴일(관리자)";

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fetchUser = async () => {
    try {
      const res = await api.get("/auth/me/");
      setUser(res.data);
    } catch (err) {
      console.error("❌ 사용자 정보 불러오기 실패:", err);
    } finally {
      setAuthChecked(true);
    }
  };

  const fetchHolidays = async (year = holidayYear) => {
    try {
      const res = await api.get(`/calendar/holidays/?year=${year}`);
      setHolidays(res.data || []);
    } catch (err) {
      console.error("❌ 공휴일 불러오기 실패:", err);
    }
  };

  const handleHolidayAdd = async () => {
    if (!holidayForm.date || !holidayForm.name) {
      alert("날짜와 공휴일명을 입력해주세요.");
      return;
    }
    try {
      await api.post("/calendar/holidays/", holidayForm);
      setHolidayForm({ date: "", name: "", holiday_type: "공휴일" });
      await fetchHolidays();
      alert("✅ 공휴일이 추가되었습니다.");
    } catch (err) {
      console.error("❌ 공휴일 추가 실패:", err);
      alert(err.response?.data?.detail || "추가 실패 (이미 등록된 날짜일 수 있습니다)");
    }
  };

  const handleHolidayUpdate = async (id) => {
    try {
      await api.patch(`/calendar/holidays/${id}/`, editingHoliday);
      setEditingHoliday(null);
      await fetchHolidays();
      alert("✅ 수정되었습니다.");
    } catch (err) {
      console.error("❌ 공휴일 수정 실패:", err);
      alert("수정 실패");
    }
  };

  const handleHolidayDelete = async (id, name) => {
    if (!window.confirm(`'${name}'을(를) 삭제하시겠습니까?`)) return;
    try {
      await api.delete(`/calendar/holidays/${id}/`);
      await fetchHolidays();
      alert("🗑️ 삭제되었습니다.");
    } catch (err) {
      console.error("❌ 공휴일 삭제 실패:", err);
      alert("삭제 실패");
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  useEffect(() => {
    if (user) {
      const rank = parseInt(user.position_rank, 10);
      if (rank === 2 || rank === 3) fetchHolidays(holidayYear);
    }
  }, [user, holidayYear]);

  if (!authChecked) {
    return <div style={{ padding: 20 }}>⏳ 권한 확인 중...</div>;
  }

  const rank = parseInt(user?.position_rank, 10);
  if (!user || (rank !== 2 && rank !== 3)) {
    return <div style={{ padding: 20, color: "red" }}>🚫 권한이 없습니다</div>;
  }

  return (
    <div style={{ padding: 20 }}>
      <h1>공휴일(관리자)</h1>

      <div style={{
        display: "flex",
        gap: "6px",
        flexWrap: isMobile ? "wrap" : "nowrap",
        alignItems: "center",
        marginBottom: "16px",
        padding: "10px 12px",
        backgroundColor: "#f8f9fa",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        maxWidth: isMobile ? "100%" : "900px",   // ✅ 폼 최대폭 제한
      }}>


        <input
          type="date"
          value={holidayForm.date}
          onChange={(e) => setHolidayForm({ ...holidayForm, date: e.target.value })}
          style={{
            height: "32px", padding: "0 8px", fontSize: "13px",
            border: "1px solid #ccc", borderRadius: "5px",
            width: isMobile ? "48%" : "140px", boxSizing: "border-box",
          }}
        />
        <input
          type="text"
          placeholder="공휴일명"
          value={holidayForm.name}
          onChange={(e) => setHolidayForm({ ...holidayForm, name: e.target.value })}
          style={{
            height: "32px", padding: "0 8px", fontSize: "13px",
            border: "1px solid #ccc", borderRadius: "5px",
            width: isMobile ? "48%" : "200px", boxSizing: "border-box",
          }}
        />
        <select
          value={holidayForm.holiday_type}
          onChange={(e) => setHolidayForm({ ...holidayForm, holiday_type: e.target.value })}
          style={{
            height: "32px", padding: "0 6px", fontSize: "13px",
            border: "1px solid #ccc", borderRadius: "5px",
            width: isMobile ? "48%" : "110px", boxSizing: "border-box",
            backgroundColor: "white",
          }}
        >
          <option value="공휴일">공휴일</option>
          <option value="대체공휴일">대체공휴일</option>
          <option value="임시공휴일">임시공휴일</option>
          <option value="근로자휴일">근로자휴일</option>
        </select>

        <button
          type="button"
          onClick={handleHolidayAdd}
          style={{
            height: "32px", padding: "0 14px", fontSize: "13px", fontWeight: "bold",
            backgroundColor: "#1976d2", color: "white", border: "none",
            borderRadius: "5px", cursor: "pointer", whiteSpace: "nowrap",
            width: isMobile ? "100%" : "90px", boxSizing: "border-box",   // ✅ 버튼 너비 고정
          }}
        >
          ＋ 추가
        </button>



        {!isMobile && <div style={{ width: "1px", height: "24px", backgroundColor: "#ccc", margin: "0 4px" }} />}

        <select
          value={holidayYear}
          onChange={(e) => setHolidayYear(parseInt(e.target.value, 10))}
          style={{
            height: "32px", padding: "0 6px", fontSize: "13px",
            border: "1px solid #ccc", borderRadius: "5px",

            width: isMobile ? "100%" : "90px", boxSizing: "border-box",
            backgroundColor: "white",
          }}
        >
          {Array.from(
            { length: 31 },
            (_, i) => 2020 + i
          ).map((y) => (
            <option key={y} value={y}>{y}년</option>
          ))}


        </select>
        <span style={{ fontSize: "12px", color: "#666", whiteSpace: "nowrap" }}>
          총 {holidays.length}개
        </span>
      </div>

      {/* ===== 목록 표시 ===== */}
      {isMobile ? (
        <div>
          {holidays.length === 0 ? (
            <div style={{ padding: "20px", textAlign: "center", color: "#999",
              border: "1px solid #ccc", borderRadius: "8px" }}>
              등록된 공휴일이 없습니다.
            </div>
          ) : holidays.map((h) => (
            <div key={h.id} style={{
              border: "1px solid #ddd", borderRadius: "10px", padding: "12px 14px",
              marginBottom: "10px", backgroundColor: "#fff",
              boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
            }}>
              {editingHoliday?.id === h.id ? (
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <input type="date" value={editingHoliday.date}
                    onChange={(e) => setEditingHoliday({ ...editingHoliday, date: e.target.value })}
                    style={{ height: "32px", padding: "0 8px", fontSize: "13px", border: "1px solid #ccc", borderRadius: "5px" }} />
                  <input type="text" value={editingHoliday.name}
                    onChange={(e) => setEditingHoliday({ ...editingHoliday, name: e.target.value })}
                    style={{ height: "32px", padding: "0 8px", fontSize: "13px", border: "1px solid #ccc", borderRadius: "5px" }} />
                  <select value={editingHoliday.holiday_type}
                    onChange={(e) => setEditingHoliday({ ...editingHoliday, holiday_type: e.target.value })}
                    style={{ height: "32px", padding: "0 6px", fontSize: "13px", border: "1px solid #ccc", borderRadius: "5px" }}>
                    <option value="공휴일">공휴일</option>
                    <option value="대체공휴일">대체공휴일</option>
                    <option value="임시공휴일">임시공휴일</option>
                    <option value="근로자휴일">근로자휴일</option>
                  </select>
                  <div style={{ display: "flex", gap: "6px" }}>
                    <button onClick={() => handleHolidayUpdate(h.id)}
                      style={{ flex: 1, height: "30px", fontSize: "12px", backgroundColor: "#1976d2",
                        color: "white", border: "none", borderRadius: "5px", cursor: "pointer" }}>저장</button>
                    <button onClick={() => setEditingHoliday(null)}
                      style={{ flex: 1, height: "30px", fontSize: "12px", backgroundColor: "#f5f5f5",
                        border: "1px solid #ccc", borderRadius: "5px", cursor: "pointer" }}>취소</button>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  <div>
                    <div style={{ fontSize: "14px", fontWeight: "bold", color: "#1976d2" }}>{h.date}</div>
                    <div style={{ fontSize: "13px", marginTop: "2px" }}>{h.name}</div>
                    <div style={{ fontSize: "11px", color: "#888", marginTop: "2px" }}>{h.holiday_type}</div>
                  </div>
                  <div style={{ display: "flex", gap: "4px" }}>
                    <button onClick={() => setEditingHoliday({ ...h })}
                      style={{ height: "28px", padding: "0 8px", fontSize: "12px",
                        border: "1px solid #1976d2", color: "#1976d2", backgroundColor: "white",
                        borderRadius: "4px", cursor: "pointer" }}>✏️</button>
                    <button onClick={() => handleHolidayDelete(h.id, h.name)}
                      style={{ height: "28px", padding: "0 8px", fontSize: "12px",
                        border: "1px solid #d32f2f", color: "#d32f2f", backgroundColor: "white",
                        borderRadius: "4px", cursor: "pointer" }}>🗑️</button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <table style={{ width: "100%", maxWidth: "900px", borderCollapse: "collapse", tableLayout: "fixed" }}>


          <thead>
            <tr style={{ backgroundColor: "#f0f0f0" }}>
              {["날짜", "공휴일명", "유형", "관리"].map((header) => (
                <th key={header} style={{
                  border: "1px solid #ccc", padding: "8px", textAlign: "center",
                  width: header === "날짜" ? "14%" : header === "공휴일명" ? "46%" :
                        header === "유형" ? "15%" : "25%",
                }}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {holidays.length === 0 ? (
              <tr>
                <td colSpan="4" style={{ border: "1px solid #ccc", padding: "20px",
                  textAlign: "center", color: "#999" }}>
                  등록된 공휴일이 없습니다.
                </td>
              </tr>
            ) : holidays.map((h) => (
              <tr key={h.id}>
                {editingHoliday?.id === h.id ? (
                  <>
                    <td style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>
                      <input type="date" value={editingHoliday.date}
                        onChange={(e) => setEditingHoliday({ ...editingHoliday, date: e.target.value })}
                        style={{ width: "100%", height: "28px", fontSize: "13px",
                          border: "1px solid #ccc", borderRadius: "4px", boxSizing: "border-box", padding: "0 6px" }} />
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>
                      <input type="text" value={editingHoliday.name}
                        onChange={(e) => setEditingHoliday({ ...editingHoliday, name: e.target.value })}
                        style={{ width: "100%", height: "28px", fontSize: "13px",
                          border: "1px solid #ccc", borderRadius: "4px", boxSizing: "border-box", padding: "0 6px" }} />
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>
                      <select value={editingHoliday.holiday_type}
                        onChange={(e) => setEditingHoliday({ ...editingHoliday, holiday_type: e.target.value })}
                        style={{ width: "100%", height: "28px", fontSize: "13px",
                          border: "1px solid #ccc", borderRadius: "4px", boxSizing: "border-box", padding: "0 4px" }}>
                        <option value="공휴일">공휴일</option>
                        <option value="대체공휴일">대체공휴일</option>
                        <option value="임시공휴일">임시공휴일</option>
                        <option value="근로자휴일">근로자휴일</option>
                      </select>
                    </td>
                    <td style={{ border: "1px solid #ccc", padding: "6px", textAlign: "center" }}>
                      <div style={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                        <button onClick={() => handleHolidayUpdate(h.id)}
                          style={{ height: "28px", padding: "0 10px", fontSize: "12px",
                            backgroundColor: "#1976d2", color: "white", border: "none",
                            borderRadius: "4px", cursor: "pointer" }}>저장</button>
                        <button onClick={() => setEditingHoliday(null)}
                          style={{ height: "28px", padding: "0 10px", fontSize: "12px",
                            backgroundColor: "#f5f5f5", border: "1px solid #ccc",
                            borderRadius: "4px", cursor: "pointer" }}>취소</button>
                      </div>
                    </td>
                  </>
                ) : (
                  <>
                    <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center",
                      fontWeight: "bold", color: "#1976d2" }}>{h.date}</td>
                    <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>{h.name}</td>
                    <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center",
                      fontSize: "13px", color: "#666" }}>{h.holiday_type}</td>
                    <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>
                      <div style={{ display: "flex", gap: "4px", justifyContent: "center" }}>
                        <button onClick={() => setEditingHoliday({ ...h })}
                          style={{ height: "28px", padding: "0 10px", fontSize: "12px",
                            border: "1px solid #1976d2", color: "#1976d2", backgroundColor: "white",
                            borderRadius: "4px", cursor: "pointer" }}>수정</button>
                        <button onClick={() => handleHolidayDelete(h.id, h.name)}
                          style={{ height: "28px", padding: "0 10px", fontSize: "12px",
                            border: "1px solid #d32f2f", color: "#d32f2f", backgroundColor: "white",
                            borderRadius: "4px", cursor: "pointer" }}>삭제</button>
                      </div>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}